
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppBar, Box, CssBaseline, ThemeProvider as MuiThemeProvider, Toolbar } from '@mui/material';

import Homepage from './components/Homepage';
import Documentpage from './Documentpage';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { UserProvider } from './contexts/UserContext';
import Header from './components/Header';
import { AuthProvider } from './utils/AuthContext';

const App = () => {
  return (
    <UserProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </UserProvider>
  );
};

const AppContent = () => {
  const { theme } = useTheme(); // From ThemeContext

  return (
<MuiThemeProvider theme={theme}>
   <AuthProvider>
  <CssBaseline />
  <Router>
    {/* Root container - handles overall layout */}
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      height: '100vh', // Use full viewport height
      overflow: 'hidden' // Prevent double scrollbars
    }}>
      {/* Sticky Header (won't cover scrollbar) */}
      <AppBar 
        position="static" // Changed from sticky to static
        elevation={0}
        sx={{ 
          flexShrink: 0, // Prevent header from shrinking
          width: '100%'
        }}
      >
        <Toolbar>
          <Header />
        </Toolbar>
      </AppBar>

      {/* Scrollable Content Area */}
      <Box 
        component="main"
        sx={{ 
          flexGrow: 1,
          overflowY: 'auto', // Only vertical scrolling
          width: '100%'
        }}
      >
        <Routes>
          
          <Route path="/" element={<Homepage />} />
          <Route path="/section/:id" element={<Documentpage />} />
        </Routes>
      </Box>
    </Box>
  </Router>
   </AuthProvider>

</MuiThemeProvider>

  );
};

export default App;